export default "__VITE_ASSET__Bq1JJDuq__"